import React, { useState } from 'react';
import ReactTruncate from 'react-truncate';
import { I18n } from '@fiverr-private/i18n-react';

import styles from './index.module.scss';

export const Truncate = ({ lines = 2, children, onReadMore }) => {
    const [isTruncated, setIsTruncated] = useState(true);

    const ellipsis = (
        <span
            onClick={() => {
                setIsTruncated((prev) => !prev);
                onReadMore();
            }}
        >
            {isTruncated && (
                <>
                    ...{' '}
                    <span className={styles.toggleControl}>
                        <I18n k="freelancer_page.truncate.read_more" />
                    </span>
                </>
            )}
        </span>
    );

    return (
        <div className={styles.truncateWrapper}>
            <ReactTruncate lines={isTruncated && lines} trimWhitespace ellipsis={ellipsis}>
                {children}
                {!isTruncated && ellipsis}
            </ReactTruncate>
        </div>
    );
};

export default Truncate;
